<template>
	<Icon v-bind="$props">
		<svg
			aria-hidden="true"
			focusable="false"
			data-prefix="fal"
			data-icon="user-slash"
			class="svg-inline--fa fa-user-slash"
			role="img"
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 0 640 512"
		>
			<path
				class="light"
				fill="currentColor"
				d="M320 32c52.94 0 96 43.06 96 96c0 35.88-20.03 66.86-49.27 83.33l26.81 21.17c32.85-23.17 54.45-61.25 54.45-104.5C447.1 57.31 390.7 0 319.1 0C266.1 0 220.1 33.47 201.3 80.71l26.8 21.16C239.5 61.68 276.2 32 320 32zM130.7 480C129.2 480 128 478.8 128 477.3C128 399.4 191.4 336 269.3 336h48.71l-40.53-32H269.3c-95.73 0-173.3 77.6-173.3 173.3c0 19.14 15.52 34.67 34.66 34.67h378.7c8.227 0 15.47-3.275 21.42-8.066L500.4 480H130.7zM633.9 483.4l-608-480c-6.938-5.453-17-4.25-22.48 2.641c-5.469 6.938-4.281 17 2.641 22.48l608 480C617 510.9 620.5 512 623.1 512c4.734 0 9.422-2.094 12.58-6.078C642 498.1 640.8 488.9 633.9 483.4z"
			></path>
		</svg>
	</Icon>
</template>

<script>
import Icon, { props } from './Icon'
export default {
	name: 'DeactivatedUserIcon',
	components: { Icon },
	props,
}
</script>
